import { Controller } from "stimulus";

export default class OfferController extends Controller {
  static targets = [
    'shareModal',
  ];

  launchShareModal() {
    this.shareModalController.open();
  }

  get shareModalController() {
    return this.application.getControllerForElementAndIdentifier(
      this.shareModalTarget,
      "modal"
    )
  }

}
